<template>
  <div class="requests-dropdowns">
    <div>
      <SItemRequestsDropdown
        v-if="!requestFromUser"
        class="mt-1 mb-2"
        ref="requestsDropdown"
        :itemRequests="itemRequests"
        :requestFromUser="reqFromUser()"
        :requestsText="requestsText"
        :itemHaveRequests="itemHaveRequests"
        :requestIcon="requestIcon"
        :mainColor="mainColor"
        :points="points"
        :cash="cash"
        :item="item"
        @decline="$emit('decline')"
      />
      <SItemRequestsDropdownFromUser
        v-if="requestFromUser"
        class="mt-1 mb-2"
        ref="requestsDropdown"
        :itemRequests="itemRequests"
        :requestFromUser="reqFromUser()"
        :requestsText="requestsText"
        :itemHaveRequests="true"
        :requestIcon="requestIcon"
        :mainColor="mainColor"
        :points="points"
        :cash="cash"
        :item="item"
        @decline="$emit('decline')"
      />
    </div>
    <!-- <div>
      <SItemRequestsDropdownHistory
        class="mt-1 mb-2"
        ref="requestsDropdownHistory"
        :itemRequests="itemRequests"
        :requestsText="requestsText"
        :itemHaveRequests="itemHaveRequests"
        :requestIcon="requestIcon"
        :mainColor="mainColor"
        :points="points"
        :cash="cash"
        :item="item"
        @decline="$emit('decline')"
        v-if="!requestFromUser && itemHaveDeclinedRequests && (item.status !=0)"
      />
    </div> -->
  </div>
</template>


<script>
import SItemRequestsDropdown from "@/material-components/molecules/SItemRequestsDropdown";
import SItemRequestsDropdownFromUser from "@/material-components/molecules/SItemRequestsDropdownFromUser";
// import SItemRequestsDropdownHistory from "@/material-components/molecules/SItemRequestsDropdownHistory";
export default {
  name: "SItemRequestsMenu",
  props: [
    "itemHaveRequests",
    "itemHaveDeclinedRequests",
    "requestsText",
    "requestIcon",
    "mainColor",
    "itemRequests",
    "points",
    "cash",
    "item",
    "requestFromUser",
  ],
  data() {
    return {
      requestIsFromUser: false,
    }
  },
  components: {
    SItemRequestsDropdown,
    SItemRequestsDropdownFromUser,
    // SItemRequestsDropdownHistory,
  },
  methods: {
    setRequestAsAccepted(requestId) {
      this.$refs.requestsDropdown.setRequestAsAccepted(requestId);
    },
    setAllRequestsAsRejected() {
      this.$refs.requestsDropdown.setAllRequestsAsRejected();
    },
    reqFromUser() {
      this.requestIsFromUser = this.requestFromUser;
      return this.requestIsFromUser;
    }
  },
};
</script>

<style lang="scss" scoped>
.requests-dropdowns {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
</style>
